import React, { useState, useEffect } from "react";

export const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewbox="0 0 24 24" fill="none"><path d="M0 12.358q0-1.825.68-3.483.692-1.67 1.992-2.97Q3.877 4.7 5.32 4.055q1.443-.643 3.113-.846.442-.048.823-.143.394-.108.74-.263.358-.167.68-.393.334-.239.656-.55.93-.894 1.956-1.37Q14.314 0 15.626 0q1.17 0 2.243.441 1.085.442 1.908 1.265.633.644 1.253 1.264.632.62 1.264 1.265.823.835 1.265 1.896Q24 7.193 24 8.374q0 .668-.131 1.24-.12.573-.358 1.098-.227.525-.585 1.014-.345.477-.787.942-.62.644-.93 1.336-.31.68-.418 1.563-.203 1.693-.835 3.125-.632 1.42-1.849 2.636-1.3 1.3-2.97 1.98Q13.48 24 11.642 24q-1.837 0-3.495-.692-1.658-.68-2.958-1.98L3.84 19.98l-1.348-1.348q-.596-.608-1.062-1.348-.465-.74-.787-1.55-.31-.812-.477-1.67Q0 13.204 0 12.358Zm1.336 0q0 1.073.274 2.075.287.99.788 1.861.513.86 1.216 1.575.716.715 1.575 1.228.87.501 1.86.788 1.003.274 2.076.274.776 0 1.587-.167.644-.131 1.336-.394.703-.274 1.252-.656.215-.155.334-.358.131-.214.131-.489 0-.202-.095-.417l-2.445-5.13q-.346-.75-.955-1.335-.596-.597-1.348-.943L3.77 7.86q-.214-.095-.429-.095-.274 0-.477.132-.203.119-.346.334-.286.429-.513.942-.215.501-.37 1.038-.143.537-.226 1.085-.072.549-.072 1.062zm13.586 4.604q.203 0 .406-.083.203-.096.334-.263.274-.346.49-.799.214-.465.369-.954.167-.501.274-1.002.108-.501.143-.93.203-2.172 1.742-3.734.704-.716 1.085-1.515.382-.8.382-1.813 0-.943-.346-1.766-.346-.823-.954-1.431-.608-.608-1.431-.954-.812-.358-1.754-.358-1.014 0-1.837.382-.823.37-1.539 1.073-.775.752-1.717 1.193-.93.441-2.016.537-.93.095-1.873.393-.93.287-1.718.823-.453.299-.453.835 0 .287.143.525.155.239.418.37l4.222 1.992q.024 0 .024.012.227.095.465.155.239.06.477.06.382 0 .668-.096.287-.107.525-.274.25-.179.477-.406.227-.238.478-.489.214-.214.334-.5.13-.287.13-.597t-.095-.597q-.083-.298-.083-.608 0-.549.203-1.038.214-.489.572-.859t.835-.572q.49-.215 1.05-.215.549 0 1.038.215.489.203.847.56.37.358.572.847.215.49.215 1.038 0 .549-.215 1.038-.203.49-.572.859-.358.358-.847.572-.477.215-1.026.215-.322 0-.62-.095-.287-.096-.597-.096t-.596.132q-.287.119-.513.333l-.477.478q-.227.214-.394.465-.167.238-.274.525-.096.286-.096.656 0 .525.215.966v.012q.012 0 .012.012l2.004 4.199q.131.262.358.417.238.155.537.155zM13.861 6.083q0 .31.107.573.12.262.322.465.203.203.465.322.263.108.573.108.31 0 .573-.108.274-.119.477-.322.203-.203.31-.465.12-.262.12-.573 0-.298-.12-.56-.107-.274-.31-.477-.203-.203-.477-.31-.263-.12-.573-.12-.31 0-.573.12-.262.107-.465.31t-.322.477q-.107.262-.107.56Z"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
